import React, { Component } from 'react';
import cx from 'classnames';
import { Field } from 'react-final-form';

import Input from 'components/common/form/GuestInput';

export default class Captcha extends Component {
    componentDidUpdate = prevProps => {
        const { captcha } = this.props;
        const { captcha: prevCaptcha } = prevProps;

        if (prevCaptcha !== captcha) {
            this.props.setFieldValue('code', null);
        }
    };

    render() {
        const { captcha } = this.props;

        if (!captcha) {
            return null;
        }

        return (
            <div className="captcha">
                <div className={cx('input')}>
                    <Field
                        name='code'
                        component={Input}
                        type='text'
                        notWrap
                        className="form-control"
                        placeholder='guest.captcha'
                    />
                </div>
                <img alt="captcha" src={`data:image/png;base64,${captcha}`} />
            </div>
        );
    }
}
